import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { RoutePaths } from '../../../Constants/Common';

type Auth0ProviderWithHistoryProps = {
    clientId: string;
    domain: string;
    audience: string;
    children?: React.ReactNode;
};

const Auth0ProviderWithHistory = ({
    clientId,
    domain,
    audience,
    children
}: Auth0ProviderWithHistoryProps): JSX.Element => {
    const navigate = useNavigate();

    const onRedirectCallback = (appState: AppState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <>
            <Auth0Provider
                domain={domain}
                clientId={clientId}
                authorizationParams={{
                    redirect_uri: `${window.location.protocol}//${window.location.host}${RoutePaths.Redirect}`,
                    audience: audience
                }}
                onRedirectCallback={onRedirectCallback}>
                {children}
            </Auth0Provider>
        </>
    );
};

export default Auth0ProviderWithHistory;
